<template>
  <!-- 远程五类（remoteselectpro/remotecomplete/remotetext/remotetreeselectpro/remotecascaderpro）：
       mode|multiple + show_search；接口/字段/查询条件等在「数据源」页配置 -->
  <a-row :gutter="16">
    <SelectionModeConfig
      v-if="MODE_TYPES.includes(config.type)"
      :config="config"
      field="mode"
    />
    <SelectionModeConfig
      v-else-if="MULTIPLE_TYPES.includes(config.type)"
      :config="config"
      field="multiple"
    />
    <ShowSearchConfig :config="config" />
    <a-col :span="24">
      <div class="remote-hint">
        远程类组件的数据源接口、显示字段、查询参数（监听/固定/上下文）、全局切换等在「数据源」页配置。
      </div>
    </a-col>
  </a-row>
</template>

<script setup lang="ts">
import { MODE_TYPES, MULTIPLE_TYPES } from '../constants';
import SelectionModeConfig from '../SelectionModeConfig.vue';
import ShowSearchConfig from '../ShowSearchConfig.vue';

defineProps<{ config: any }>();
</script>

<style scoped lang="less">
.remote-hint {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  margin-top: 4px;
}
</style>
